import { Roster } from "@/interfaces/meeting/roster";

export const roster: Roster = {};

// Check if this attendeeId corresponds to a content share
export const isAttendeeIdForContent = (attendeeId: string): boolean =>
  attendeeId.endsWith("#content");

// Get the attendee id without the #content suffix
export const attendeeIdWithoutContent = (attendeeId: string): string =>
  attendeeId.split("#")[0];
